import React from 'react'
import { Trans } from '@lingui/react'
import { useApolloClient } from '@apollo/client'
import TopBarSearch from './TopBarSearch'
import useNotifications from '../hooks/useNotifications'
import useTracking from '../hooks/useTracking'
import search from '../../api/search'

const TopBarSearchWithState = () => {
    const apolloClient = useApolloClient()
    const { dispatchError } = useNotifications()
    const { trackError } = useTracking()
    return (
        <TopBarSearch
            onSearch={async (searchValue) => {
                try {
                    const response = await search(apolloClient, searchValue)
                    return response
                } catch (e) {
                    trackError(e)
                    dispatchError({
                        title: <Trans id="Something went wrong!" />,
                        content: e.message,
                    })
                    return []
                }
            }}
        />
    )
}

export default TopBarSearchWithState
